// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "path[data-v-5e926309]{fill:#fff}.dark path[data-v-5e926309]{fill:#4a4a5a}", "",{"version":3,"sources":["webpack://./resources/js/Icons/IconPause.vue"],"names":[],"mappings":"AAAA,sBAAK,SAEL,CAFe,4BAAW,YAM1B","sourcesContent":["path{fill:#fff}.dark path{fill:#4a4a5a}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
